module.exports = {
	site:{														//站点配置
		name: '吉浦迅科技', 									//网站名称
		color: '#00AFFF', 										//程序主色
	},
	api:{														//接口配置
		baseUrl: 'https://api.gpus.cn/v1/', 			            //接口根域名
		appKey: 'v1', 											//接口版本号
		version: 'v1', 											//接口key
		appSecret: 'qwertyuiopasdfghjklzxcvbnm123', 			//接口secret
        oauth_url: 'http://admin.gpus.cn', 			            //授权域名
	    url: 'https://gpus.cn', 			    		            //访问
	},
};
